import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Folder} from '../models/folder';

@Injectable({
  providedIn: 'root'
})
export class FolderService {

  constructor (private db: AngularFirestore,) { }

  select () {
    return this.db.collection<Folder>('sbccv_document_folders', ref => ref
      .orderBy('name', 'asc')).snapshotChanges()
  }

  insert (entity: Folder) {
    return this.db.collection('sbccv_document_folders').add(Object.assign({}, entity));
  }

  update (entity: Folder) {
    return this.db.collection('sbccv_document_folders').doc(entity.id).set(Object.assign({}, entity), {'merge': true});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_document_folders').doc(entity_id).delete();
    //return this.db.collection('sbccv_document_folders').doc(entity_id).set({'deleted': true}, {'merge': true});
  }

  canDelete (entity_id: any) {
    return this.db.collection<Document>('sbccv_documents', ref => ref
      .where('folder_id', '==', entity_id))
      .get()
  }

}
